module.exports = __webpack_public_path__ + "img/two-enabled-big.c07fecf8.svg";